import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'

import { config, type GetToken } from '~/config'
import { embedded, getEmbedToken } from '~/embed'

/**
 * Returns a stable async token getter. Embedded in the dashboard, the ONLY
 * source is the parent-posted token (read fresh each call so parent refreshes
 * take effect). Otherwise prefers VITE_DEV_AUTH_TOKEN when set (local fast
 * path), then asks Auth0 for an access token scoped to the Zunou API
 * audience. Used for both GraphQL and Pusher channel auth.
 */
export function useGetToken(): GetToken {
  const { getAccessTokenSilently } = useAuth0()

  return useCallback<GetToken>(async () => {
    if (embedded) return getEmbedToken()
    if (config.devAuthToken) return config.devAuthToken
    try {
      return await getAccessTokenSilently({
        authorizationParams: { audience: config.auth0Audience },
      })
    } catch {
      return null
    }
  }, [getAccessTokenSilently])
}
